import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=2f5b0fe7&scoped=true"
import script from "./contact.js?vue&type=script&lang=js&external"
export * from "./contact.js?vue&type=script&lang=js&external"
import style0 from "./contact.scss?vue&type=style&index=0&id=2f5b0fe7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b0fe7",
  null
  
)

export default component.exports